export const TENANTS_THEME = {
  belsol: {
    primary: "#FDF001",
    text: "#000000"
  }
};
